import React, {useContext, useState} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import GridBlock from "components/GridBlock";
import EZamowieniaIcon from "components/icon/EZamowieniaIcon";
import {makeStyles} from "@material-ui/styles";
import useEzamowieniaOauth from "hooks/useEzamowieniaOauth";
import WorkableButton from "components/button/WorkableButton";
import useSnackbar from "hooks/useSnackbar";
import Tr from "translations/Translations";
import {PP_REQUIRED_GROUPS} from "constants/EzamowieniaRequiredGroups";

const useStyle = makeStyles(theme => ({
    inputWithButton: {
        '&>*:first-child': {
            flexGrow: 1,
            marginRight: theme.spacing(2)
        }
    },
}))


function BasicData(
    {
        id,
        tenderPlanDisabled,
        formikProps
    }) {
    const classes = useStyle();
    const [ezWorking, setEzWorking] = useState(false);
    const editable = getObjectValue('_editable', formikProps.values, true);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict, getDynamicDict, loadDynamicDictionaries} = useContext(FormTranslationContext)
    const {authorizeEzamowienia} = useEzamowieniaOauth();
    const {enqueueSuccessSnackbar} = useSnackbar();

    const loadPlanItems = () => {
        setEzWorking(true);
        authorizeEzamowienia(()=> {
            loadDynamicDictionaries().then((resp)=> {
                if(resp) {
                    enqueueSuccessSnackbar(Tr("bzp_plan_items_loaded"));
                    if(resp["RKT-0510"] && resp["RKT-0510"].items && resp["RKT-0510"].items.length > 0) {
                        const bzpNumber = resp["RKT-0510"].items[0].value;
                        if(bzpNumber && gVal("tenderPlanNumber") !== bzpNumber) {
                            formikProps.setFieldValue(gId("tenderPlanNumber"), bzpNumber);
                            enqueueSuccessSnackbar(Tr("bzp_plan_number_loaded"));
                        }
                    }


                }
            }).finally(()=>  setEzWorking(false));
        },()=> {
            setEzWorking(false)
        }, PP_REQUIRED_GROUPS)
    }

    return (<>
        <NoticeGlossaryInput
            id={gId("refersTo")}
            formikProps={formikProps}
            items={getDict("SL.MO.010")}
            required
            disabled={updateNotice}
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("refersToSocialServices")}
            required
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("name")}
            required
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("tenderPlanRelated")}
            required
            disabled={updateNotice && tenderPlanDisabled}
        />
        <Collapse in={gVal("tenderPlanRelated") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("tenderPlanNumber")}
                required
                disabled={updateNotice && tenderPlanDisabled}
            />
            <GridBlock wrap="nowrap" className={classes.inputWithButton}>

            <NoticeGlossaryInput
                id={gId("tenderPlanItemIdentities")}
                items={getDynamicDict("RKT-05101")}
                formikProps={formikProps}
                multiple
                required
                useObjectInsteadOfValues
                disabled={updateNotice && tenderPlanDisabled}
            />
                {
                    !!loadDynamicDictionaries && !(updateNotice && tenderPlanDisabled) && <WorkableButton disabled={!editable || ezWorking} working={ezWorking} Icon={EZamowieniaIcon} onClick={loadPlanItems}>Wczytaj</WorkableButton>
                }
            </GridBlock>
        </Collapse>
        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("onlyArt94Suppliers")}
            required
        />
        <Collapse in={gVal("onlyArt94Suppliers") === true}>
            <NoticeGlossaryInput
                id={gId("art94Suppliers")}
                items={getDict("SL.MO.015")}
                formikProps={formikProps}
                multiple
                required
            />
        </Collapse>

        <Collapse in={gVal("refersToSocialServices") === true}>
            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("onlyArt361Suppliers")}
                required={gVal("refersToSocialServices")}
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("ueFunded")}
            required
        />
        <Collapse in={gVal("ueFunded") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("ueProgramName")}
                required
            />
        </Collapse>

    </>)
}

BasicData.propTypes = {};

export default BasicData;
